import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AccoutDetailsResponse } from '../../shared/models/accountDetailsResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import {animate, state, style, transition, trigger} from '@angular/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggle, MatButtonToggleModule } from '@angular/material/button-toggle';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { MatInputModule } from '@angular/material/input';
import * as XLSX from 'xlsx';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';

export enum ToggleEnum { //used for mat toggle
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6
}

@Component({
    selector: 'div.dtf-accountpage',
    imports: [SharedTranslateModule, MatInputModule, SessionTimeoutComponent,MatTableModule, MatPaginator, MatSort, MatSortModule, ReactiveFormsModule, MatExpansionModule, MatToolbarModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatMenuModule, FormsModule, MatButtonToggleModule],
    templateUrl: './accountdetails.component.html',
    providers: [],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})
export class AccountdetailsComponent implements OnInit {
  title = 'Content Section of the Page';
  router: Router;
  path = '';
  loginRedirect = '';
  hideSingleSelectionIndicator=true;
  accountRedirect = '';
  token: string;
  brandId: string;
  loginAttempt = false;
  isLoginattempt = '';
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  usUrl: string;
  caUrl: string;
  azURL: string;
  agentview: string;
  agentId: string;
  bodyLoaded = false;
  dbLoaded = false;
  tableLoaded = true;
  isFrench = false;
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  recAccCount ='';
  totalDue ='';
  ciamId = sessionStorage.getItem('loginID');
  accountDetailsRes: AccoutDetailsResponse[];
  termAccDetailsRes: AccoutDetailsResponse[];
  maturedAccList: AccoutDetailsResponse[];
  //used for mat-toggle
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option6;
  
  // Table columns
  initColumns: any[] = [
    {
      name: 'contractNum',
      display: 'Account',
      displayFR: 'Numéro de contrat',
      dispFormat: 'contract'
    },
    {
      name: 'lastPayRcvd',
      display: 'Last Payment',
      displayFR: 'Dernier paiement reçu',
      dispFormat: 'currency'
    },
    {
      name: 'contractType',
      display: 'Account Type',
      displayFR: 'Type de contrat',
      dispFormat: ''
    },
    {
      name: 'termDate',
      display: 'Maturity Date',
      displayFR: 'Date de maturité',
      dispFormat: 'date'
    },
    {
      name: 'totalDue',
      display: 'Current Due',
      displayFR: 'Solde actuel',
      dispFormat: 'currency'
    },
    {
      name: 'currentDt',
      display: 'Due Date',
      displayFR: 'Date d\'échéance',
      dispFormat: 'date'
    },
   {
      name: 'status',
      display: 'Status',
      displayFR: 'Statu',
      dispFormat: ''
    }
  ];
  displayedColumns: any[] = this.initColumns.map(col => col.name);

  filterActive = false;
  filter = false;
  rowCount = 0;
  value = '';


  dataSource: MatTableDataSource<AccoutDetailsResponse>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  constructor(router: Router,private dtfhomepageService: DTFHomepageService, public auth: AuthorizationService,
              private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil

    ){
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.accountDetailsRes =[];
    this.dataSource = new MatTableDataSource(this.accountDetailsRes);
  }

  ngAfterViewInit() {
    this.getAccountDetailsListByUserId();
    this.getTerminatedAccounts();
    this.getMaturedAccounts();
  }

  applyFilter(event: Event) {
    this.selectedState = undefined; //removes toggled mat-toggle
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
  }
       
  onChange($event) { //Used for mat-toggle conditions to filter DB
    this.selectedState = $event.value;
    this.dataSource = new MatTableDataSource(this.accountDetailsRes);
    if(this.selectedState===0){
      this.dataSource.filter = 'Loan'.trim().toLowerCase();
    }
    else if(this.selectedState===1){
      this.dataSource.filter = 'Lease'.trim().toLowerCase();
    }
    else if(this.selectedState===2){
      this.dataSource = new MatTableDataSource(this.maturedAccList);
    }
    else if(this.selectedState===3){
      this.dataSource = new MatTableDataSource(this.termAccDetailsRes);
    }
    else if(this.selectedState===4){
      this.dataSource.filter = 'Dynamic'.trim().toLowerCase();
    }
    else{
      this.dataSource.filter = '';
    }
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.rowCount = this.dataSource.filteredData.length;
    return this.dataSource;

  }

    /** Gets the total filtered cost of all transactions. */
    getTotalFilteredCost() {
      return this.dataSource.filteredData.map(t => Number(t.totalDue)).reduce((acc, value) => acc + value, 0);
    }


  ngOnInit() {
    sessionStorage.removeItem('amortAccount');
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    const language = (window as any).mbfs.language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.brandId = sessionStorage.getItem('brandId');
    this.token = sessionStorage.getItem('ciamToken');

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
        this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
        this.currentCountry = val;
    });
    this.isFrench = ('fr-CA' === language) ? true : false; //checks if language is french or english for Canada

    //this.getAlerts();
    // this.getAccountDetailsListByUserId();
  }

  checkUrl(redirect: string) {
    this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('classicredirect', 'yes');
    this.formatAccountURl(redirect);
  }

  checkUrlParam(redirect: string, account: string) {
    this.isLoginattempt = sessionStorage.getItem('loginAttempt');
    sessionStorage.setItem('amortAccount', account);
    sessionStorage.setItem('classicredirect', 'yes');
    this.formatAccountURl(redirect);
  }
  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //       for (var i = 0; i < res.length; i++) {
  //       if( this.currentCountry === 'CA'){
  //         if (res[i].bannerType === 'Alert' &&  res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //         res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //         this.alerts = res[i];
  //         this.dbData = true;
  //          }
  //       }
  //       else{
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       }
  //     });
  // }

  formatAccountURl(redirect: string) {
    this.bodyLoaded = true;
    window.scrollTo(0, 0); // used to scroll to top of page
    if (this.countryFlag === 'CA') //CA Logic
    {
      this.azURL =  this.accountRedirect + '?blink=' + redirect;
      if(this.langFlag === 'fr-CA'){
          if (redirect === 'insurance'){
            this.azURL =  this.usUrl + '/ca/fr/home/insurance';
          }
          else if (redirect === 'payoff'){
            this.azURL =  this.usUrl + '/ca/fr/home/payoff';
          }
          else if (redirect ==='amortization'){
            this.azURL =  this.usUrl + '/ca/fr/home/amortization';
          }
          else if (redirect ==='documentcenter'){
            this.azURL =  this.usUrl + '/ca/fr/home/documentcenter';
          }
      }
      else{
        if (redirect === 'insurance'){
          this.azURL =  this.usUrl + '/ca/en/home/insurance';
        }
        else if (redirect === 'payoff'){
          this.azURL =  this.usUrl + '/ca/en/home/payoff';
        }
        else if (redirect ==='amortization'){
          this.azURL =  this.usUrl + '/ca/en/home/amortization';
        }
        else if (redirect ==='documentcenter'){
          this.azURL =  this.usUrl + '/ca/en/home/documentcenter';
        }
      }
    }
    else{ //US Logic
      this.azURL =  this.accountRedirect + '?blinkImage=null&blink=' + redirect;
      if (redirect === 'insurance'){
        this.azURL =  this.usUrl + '/home/insurance';
      }
      if (redirect === 'payoff'){
        this.azURL =  this.usUrl + '/home/payoff';
      }
      if (redirect === 'dynamic'){
        this.azURL =  this.usUrl + '/home/dynamicdashboard';
      }
      if (redirect === 'pay'){
        this.azURL =  this.usUrl + '/home/pay';
      }
      else if (redirect ==='amortization'){
        this.azURL =  this.usUrl + '/home/amortization';
      }
      else if (redirect ==='documentcenter'){
        this.azURL =  this.usUrl + '/home/documentcenter';
      }
      // else if (redirect ==='invoice'){
      //   this.azURL =  this.usUrl + '/home/invoice';
      // }
    }
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
  }, 1000);  //1s
  }

  getAccountDetailsListByUserId() {
    this.tableLoaded = false;
  const accountDetailsRequest = {
    ciamId : this.ciamId ,
    ciamAZCode :this.token
  };
  this.auth.getAccountDetailsListByUserId(accountDetailsRequest).subscribe(res => {
    this.tableLoaded = true;
      this.accountDetailsRes = res.accountdetailsList;
      this.dataSource = new MatTableDataSource(this.accountDetailsRes);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.filterPredicate = function(data, filter: string): boolean {
        return data.contractNum.toLowerCase().includes(filter) || data.status.toLowerCase().includes(filter) || data.contractType.toLowerCase().includes(filter);
      };
      setTimeout(()=>{
        this.dbLoaded = true;
        this.filter = true;
        this.rowCount = this.dataSource.filteredData.length;
   });
  });
}

getTerminatedAccounts() {
  this.tableLoaded = false;
  const accountDetailsRequest = {
    ciamId : this.ciamId ,
    ciamAZCode :this.token
  };
  this.auth.getTerminatedAccounts(accountDetailsRequest).subscribe(res => {
    this.tableLoaded = true;
      this.termAccDetailsRes = res.accountdetailsList;
  });
}
getMaturedAccounts() {
  this.tableLoaded = false;
  const accountDetailsRequest = {
    ciamId : this.ciamId ,
    ciamAZCode :this.token
  };
  this.auth.getMaturedAccounts(accountDetailsRequest).subscribe(res => {
    this.tableLoaded = true;
      this.maturedAccList = res.accountdetailsList;
  });
}
exportToExcel(): void {
  const fileName = `AccountDetails_${new Date().toISOString()}.xlsx`;

  // ✅ Select header labels (English or French)
  const header = this.initColumns.map(col =>
    this.isFrench ? col.displayFR : col.display
  );

  // ✅ Get actual data from MatTableDataSource
  const dataArray = this.dataSource.filteredData?.length
    ? this.dataSource.filteredData
    : this.dataSource.data;

  // ✅ Map data (only currency formatted)
  const data = dataArray.map(row => {
    const obj: any = {};
    this.initColumns.forEach(col => {
      const headerLabel = this.isFrench ? col.displayFR : col.display;

      if (col.dispFormat === 'currency') {
        const value = row[col.name];
        // Format as $1,234.56 (with commas)
        obj[headerLabel] = value !== null && value !== undefined && !isNaN(value)
          ? `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          : '';
      } else {
        obj[headerLabel] = row[col.name];
      }
    });
    return obj;
  });

  // ✅ Create worksheet and workbook
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'AccountDetails');

  // ✅ Save Excel file
  XLSX.writeFile(wb, fileName);
}



}
